import styled from 'styled-components';
import {breakPoint} from './var';


export const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  @media (min-width: ${breakPoint.min}) {
    max-width: 120rem;
  }
`;

